import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

//import homeModule from './Home/module';

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        lang: null,
        loggedIn: false,
        miniBasket: null
    },
    mutations: {
        setLoggedIn(state, payload) {
            state.loggedIn = payload;
        },
        setMiniBasket(state, payload) {
            state.miniBasket = payload;
        }
    },
    actions: {
        setLoggedIn({ commit }, loggedIn) {
            return new Promise((resolve, reject) => {
                commit("setLoggedIn", loggedIn);

                resolve();
            });
        },
        getMiniBasket({ commit }) {
            axios.get("/api/checkout/minibasket").then(x => {
                commit("setMiniBasket", x.data);
            });
        }
    },
    modules: {
        //home: homeModule,
    }
});

export default store;